import React, { useState } from 'react';
import { Box, TextField, Button, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useMediaQuery from '@mui/material/useMediaQuery';
import { login } from '../../../utils/api';
import { setSession } from '../../../utils/session';
import { createNotification } from '../../../utils/alerts';
import { getErrorMessage } from '../../../utils/errorUtils';
import AdminAuthLayout from '../../../components/admin/AdminAuthLayout';
import '../admin-auth.scss';

const textFieldSx = {
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': { borderColor: '#434851' },
    },
    '& .MuiInputLabel-root.Mui-focused': { color: '#434851' },
};

export default function AdminLoginPage() {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:600px)');
    const [form, setForm] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = await login(form);
            setSession(data);
            createNotification('success', 'Login realizado com sucesso!', isMobile);
            navigate('/admin/dashboards');
        } catch (err) {
            createNotification('error', getErrorMessage(err, 'Credenciais inválidas. Tente novamente.'), isMobile);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AdminAuthLayout title="Acesso Admin">
            <Box component="form" onSubmit={handleSubmit} className="admin-auth-form">
                <TextField
                    fullWidth
                    label="E-mail"
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                    size="small"
                    sx={textFieldSx}
                />
                <TextField
                    fullWidth
                    label="Senha"
                    name="password"
                    type="password"
                    value={form.password}
                    onChange={handleChange}
                    required
                    size="small"
                    sx={textFieldSx}
                />
                <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    disabled={loading}
                    className="admin-auth-submit-btn"
                >
                    {loading ? <CircularProgress size={22} color="inherit" /> : 'Login'}
                </Button>
                <Button
                    variant="text"
                    fullWidth
                    onClick={() => navigate('/admin/forgot-password')}
                    className="admin-auth-link-btn"
                >
                    Esqueci minha senha
                </Button>
            </Box>
            <ToastContainer />
        </AdminAuthLayout>
    );
}
